<template>
  <div
    id="map-instruction"
    class="map-instruction"
  >
    <Button
      id="evmaps"
      type="button"
      class="align-self-end p-button-sm grey"
    >
      <i class="fas fa-info-circle" />
      <b-tooltip
        container="#map-instruction"
        target="evmaps"
        html="true"
        placement="right"
      >
        <div v-if="locationSelectionAllowed">
          <p>{{ $t('processes.messages.instruction_part_1') }}</p>
          <p>{{ $t('processes.messages.instruction_part_2') }}</p>
        </div>
        <div v-else>
          <p>{{ $t('processes.messages.instruction_part_3') }}</p>
          <p>{{ $t('processes.messages.instruction_part_4') }}</p>
        </div>
      </b-tooltip>
    </Button>
  </div>
</template>
<script>
import { image } from '@/helpers/assets'
import Button from 'primevue/button'
import Tooltip from 'primevue/tooltip'

export default {
  name: 'LocationInstruction',
  components: { Button },
  directives: {
    'tooltip': Tooltip,
  },
  props: {
    locationSelectionAllowed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      image: image,
      definitive: 'chargingpoint-definitive',
      suggestion: 'chargingpoint-suggestion'
    }
  }
}
</script>
<style scoped lang="scss">
.map-instruction {
  position: absolute;
  margin: 0.7em 0 0 0.5em;
  z-index: 1;

}

:deep .tooltip.b-tooltip {
  .tooltip-inner {
    min-width: 470px !important;
    padding: 1.5em;
    text-align: left;
    margin-top: 4em;
  }
}
.p-button.grey {
  &:hover, &:enabled:hover, &:enabled:active {
    border-color: #6c757d;
    background: #666;
    box-shadow: none;
  }
  &.p-button-sm {
    background: #6c757d;
    border-color: #6c757d;
    padding: 0.7em;
  }
}
</style>
